import { useMemo } from 'react';
import { EventTemplate } from 'types/eventTemplates';
import useCollection from './useCollection';

const useEventTemplates = (restaurantId: string | null) => {
  const [collection] = useCollection<EventTemplate>(
    `restaurants/${restaurantId ?? ''}/eventsV02`
  );

  const eventTemplates = useMemo(
    () =>
      collection.data
        .filter((template) => !template.archivedAt)
        .sort((a, b) =>
          (a.title?.de ?? a.title?.en ?? '').localeCompare(
            b.title?.de ?? b.title?.en ?? ''
          )
        ),
    [collection.data]
  );

  return {
    eventTemplates,
    loading: collection.loading,
    error: collection.error,
  };
};

export default useEventTemplates;
